/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx, Text } from 'theme-ui'

const IconListSection = ({ bgOverride, cards, description, title }) => {
  return (
    <Box bg={bgOverride || 'backgroundMedium'} pt={7} pb={8}>
      <Container>
        {title && (
          <Grid columns={[1, null, 12]}>
            <Box
              mb={[3, 4]}
              sx={{
                gridColumn: [null, null, '2 / 12', '3 / 11'],
                textAlign: 'center',
              }}
            >
              <Heading as="h2" variant="title2">
                {title}
              </Heading>
              {description && (
                <Box
                  variant="text.body1"
                  mt={2}
                  sx={{
                    p: { m: 0 },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: description.childMarkdownRemark.html,
                  }}
                />
              )}
            </Box>
          </Grid>
        )}
        <Grid columns={[1, 2, 4]} sx={{ rowGap: 5 }}>
          {cards.map((card, index) => {
            return (
              <Box
                key={`icon-list-expanded-card-${index}`}
                px={1}
                sx={{ textAlign: 'center' }}
              >
                <Box mb={[2, 3]}>
                  <img
                    src={`/images/icons/${card.subtitle}.svg`}
                    alt=""
                    aria-hidden="true"
                    sx={{ height: '112px', width: '112px' }}
                  />
                </Box>
                <Text as={title ? 'h3' : 'h2'} variant="callout1">
                  {card.title}
                </Text>
                {card.description && (
                  <Box
                    variant="text.body3"
                    mt={2}
                    sx={{
                      p: { m: 0 },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: card.description.childMarkdownRemark.html,
                    }}
                  />
                )}
              </Box>
            )
          })}
        </Grid>
      </Container>
    </Box>
  )
}

export default IconListSection
